import { AxiosInstance } from 'axios'

export class Carrier {
  constructor(
    protected readonly api: AxiosInstance,
    protected readonly path: string
  ) {}
}
